import React from "react";
import styles from "./DropdownContainer.module.scss";
// We no longer need useClickOutside or useState here
import { useAppSelector } from "../../../redux/hooks";
import dropdownArrowLight from "../../../assets/images/LightTheme/down_arrow_light.svg";
import dropdownArrowDark from "../../../assets/images/DarkTheme/down_arrow_dark.svg";
import ErrorMessage from "../../../utils/fieldErrorMesssage";

interface DropdownContainerProps {
  label: string;
  value: string;
  isOpen: boolean;
  onToggle: () => void;
  dropdownRef: React.RefObject<HTMLDivElement>;
  children: React.ReactNode;
  size?: "sm" | "md";
  className?: string;
  errorMsg?: string;
  invalid?: boolean;
  addScroll?: boolean;
}

const DropdownContainer: React.FC<DropdownContainerProps> = ({
  label,
  value,
  isOpen,
  onToggle,
  dropdownRef,
  children,
  size = "md",
  className = "",
  errorMsg,
  invalid,
  addScroll = false,
}) => {
  const currentTheme = useAppSelector((state) => state.theme.currentTheme);
  const dropdownArrow =
    currentTheme === "light" ? dropdownArrowLight : dropdownArrowDark;

  return (
    <div ref={dropdownRef} className={`${styles.dropdown} ${className}`}>
      <div
        className={styles.input_wrapper}
        onClick={onToggle}
        data-testid="toggle_dropdown_testId"
      >
        <input
          type="text"
          className={`${styles.dropdown_input} ${isOpen ? styles.selected_input : ""} ${value ? styles.input_with_text : ""}  ${styles[`size_${size}`]} ${invalid ? styles.invalid : ""}`}
          value={value}
          readOnly
        />
        {!(size === "sm" && value) && (
          <label className={styles.placeholder}>{label}</label>
        )}
        <img
          src={dropdownArrow}
          alt="Down Arrow"
          className={`${styles.arrow_icon} ${isOpen ? styles.rotate : ""}`}
        />

        {isOpen && (
          <div
            className={`${styles.dropdown_menu} ${addScroll ? styles.dropdown_height : ""}`}
            data-testid="dropdown_list_testId"
          >
            {children}
          </div>
        )}
      </div>
      <ErrorMessage message={errorMsg} className={styles.error_message} />
    </div>
  );
};

export default DropdownContainer;
